import {API_URL, API_URL_V2 } from '../constants/index.js';
import {
    COMMUNITY,
    COMMUNITY_SUCCESS,
    COMMUNITY_ERROR,
    COMMUNITY_ID,
    COMMUNITY_ID_SUCCESS,
    COMMUNITY_ID_SUCCESS_CL,
    COMMUNITY_ID_ERROR,
    ADD_COMMUNITY,
    ADD_COMMUNITY_SUCCESS,
    ADD_COMMUNITY_ERROR,
    UPDATE_COMMUNITY,
    UPDATE_COMMUNITY_SUCCESS,
    UPDATE_COMMUNITY_ERROR,
    DELETE_COMMUNITY,
    DELETE_COMMUNITY_ERROR,
    DELETE_COMMUNITY_SUCCESS,
    PUTUSERBYCOMMUNITY_COMMUNITY,
    PUTUSERBYCOMMUNITY_COMMUNITY_SUCCESS,
    PUTUSERBYCOMMUNITY_COMMUNITY_ERROR,
    COMMUNITY_MEALS_TYPE,
    COMMUNITY_MEALS_TYPE_SUCCESS,
    COMMUNITY_MEALS_TYPE_ERROR,
    UPDATE_COMMUNITY_IMAGE,
    UPDATE_COMMUNITY_IMAGE_SUCCESS,
    UPDATE_COMMUNITY_IMAGE_ERROR,
    GET_TAGS_COMMUNITY,
    GET_TAGS_COMMUNITY_ERROR,
    GET_TAGS_COMMUNITY_SUCCESS,
    COMMUNITY_BY_TAGS,
    COMMUNITY_BY_TAGS_ERROR,
    COMMUNITY_BY_TAGS_SUCCESS,
    CL_COMMUNITY,
    CL_COMMUNITY_ERROR,
    CL_COMMUNITY_SUCCESS
} from '../constants/communityConstants.js';

import {sweetAlert} from '../components/Alert/sweetAlert'

//#region GET COMMUNITY
export function getCommunity(data) {
    return {
        type: COMMUNITY,
        data
    }
};

export function getCommunitySuccess(data) {
    return {
        type: COMMUNITY_SUCCESS,
        data
    }
};

export function getCommunityError(data) {
    return {
        type: COMMUNITY_ERROR,
        data
    }
};

export function getAllCommunities(data) {
    return dispatch => {
        dispatch(getCommunity());

        
        fetch(API_URL+'communities/communities',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+ localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getCommunitySuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getCommunityError(error));

            })
    }
};


export function getAllCLCommunities(data) {
    return dispatch => {
        dispatch(getCommunity());

        
        fetch(API_URL_V2+'communities/communities',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+ localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getCommunitySuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getCommunityError(error));

            })
    }
};

//#endregion

//#region GET BY ID

export function getCommunityId(data) {
    return {
        type: COMMUNITY_ID,
        data
    }
};

export function getCommunityIdSuccess(data) {
    return {
        type: COMMUNITY_ID_SUCCESS,
        data
    }
};

export function getCommunityIdSuccessCL(data) {
    return {
        type: COMMUNITY_ID_SUCCESS_CL,
        data
    }
};

export function getCommunityIdError(data) {
    return {
        type: COMMUNITY_ID_ERROR,
        data
    }
};

export function getCommunityById(id) {
    return dispatch => {
        dispatch(getCommunityId());
        return fetch(API_URL+'communities/communities/' + id,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+ localStorage.getItem('token')
            }
            })
            .then(res => {
                const json = res.json()
                return json
            })
            .then(res => {
                dispatch(getCommunityIdSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getCommunityIdError(error));

            })
    }
};

export function getCLCommunityById(id) {
    return dispatch => {
        dispatch(getCommunityId());
        return fetch(API_URL_V2+'communities/communities/' + id,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+ localStorage.getItem('token')
            }
            })
            .then(res => {
                const json = res.json()
                return json
            })
            .then(res => {
                dispatch(getCommunityIdSuccessCL(res));
                return res;
            })
            .catch(error => {
                dispatch(getCommunityIdError(error));

            })
    }
};

export function getCommunityByIdAsync(id) {
    return dispatch => {
        dispatch(getCommunityId());
        return fetch(API_URL+'communities/communities/' + id,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+ localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getCommunityIdSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getCommunityIdError(error));
            })
    }
};

export  async function WaitGetCommunityById(id) {

    try{
        let RES = undefined;
        let JSON = undefined;
        let result = [];
            
        RES = await fetch(API_URL+'communities/communities/' + id,
        {
            method: 'GET',
            headers: { 
                'Content-Type':'application/json' ,
                'Cache-Control': 'no-store',
                'Pragma': 'no-cache',
                'Expires': '0',
                'Authorization': 'Bearer '+ localStorage.getItem('token')
        }
        });
    
        if(RES && RES.status >= 200 && RES.status < 300)
            JSON = await RES.json();
    
        if(JSON && Array.isArray(JSON) && JSON.length > 0)
        result = JSON;
    
        return result;

    }catch(err){
        
        const message = `An error has occurred while getting the community`

        sweetAlert('error',message,'alert_WaitCommunity_Error');
        return []
    }
};


export  async function WaitGetGetAllCommunities() {

    try{
        let RES = undefined;
        let JSON = undefined;
        let result = [];
            
        RES = await fetch(API_URL+'communities/communities',
        {
            method: 'GET',
            headers: { 
                'Content-Type':'application/json' ,
                'Cache-Control': 'no-store',
                'Pragma': 'no-cache',
                'Expires': '0',
                'Authorization': 'Bearer '+ localStorage.getItem('token')
        }
        });
    
        if(RES && RES.status >= 200 && RES.status < 300)
            JSON = await RES.json();
    
        if(JSON && Array.isArray(JSON) && JSON.length > 0)
            result = JSON;
    
        return result;
        
    }catch(err){
        const message = `An error has occurred while getting the communities`

        sweetAlert('error',message,'alert_GetCommunity_Error');
        return []
    }
   
};

//#endregion

//#region ADD COMMUNITY
export function addCommunity(data) {
    return {
        type: ADD_COMMUNITY,
        data
    }
};

export function addCommunitySuccess(data) {
    return {
        type: ADD_COMMUNITY_SUCCESS,
        data
    }
};

export function addCommunityError(data) {
    return {
        type: ADD_COMMUNITY_ERROR,
        data
    }
};

export function AddCommunity(data) {
    return dispatch => {

        dispatch(getCommunity());
        fetch(API_URL+'communities/communities',
            {
                body:JSON.stringify(data),
                method: 'POST',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(r =>  r.json().then(data => ({status: r.status, body: data})))
            .then(res => {  

                let message='';
                if(res.status===201)
                {
                    dispatch(addCommunitySuccess(res.body));
                    message = `The community ${data.communityName} has been added successfully`
                    sweetAlert('success',message,'alert_AddCommunity_Success');
                    return res.body;
                   
                }else if(res.status===400){
                    message = `An error occurred trying to add the community ${res.body.message} `;
                    sweetAlert('error',message,'alert_AddCommunity_Error');
                    dispatch(addCommunityError(message));
                    return res.body;
                }            
            })
            // .then( (res) =>{
            //     if(res.status==201)
            //     {
            //         const message = `The Community ${data.communityName} has been added successfully`

            //         GeneralAlert('success',message);
            //     }
            // })
            .catch(error => {
                dispatch(addCommunityError(error));

                const message = `An error occurred trying to add the community ${data.name} `

                sweetAlert('error',message, 'alert_AddCommunity_Error');
            })
    }
};

//#endregion

//#region UPDATE COMMUNITY
export function updCommunity(data) {
    return {
        type: UPDATE_COMMUNITY,
        data
    }
};

export function updCommunitySuccess(data) {
    return {
        type: UPDATE_COMMUNITY_SUCCESS,
        data
    }
};

export function updCommunityError(data) {
    return {
        type: UPDATE_COMMUNITY_ERROR,
        data
    }
};

export function UpdateCommuny(id,data, styleObj) {
    return dispatch => {
        
        dispatch(updCommunity());
        
        fetch(API_URL+'communities/community/'+id,
            {
                method: 'PUT',
                body:JSON.stringify(data),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {

                let message=''
                if(res.status===204)
                {
                    dispatch(updCommunitySuccess(res));

                    message = `The Community ${data.communityName} has been updated succesesfully`
                    sweetAlert('success',message,'alert_UpdateCommunity_Success', styleObj);

                    return res;

                } else if(res.status===400){
                     message = 'An error occurred trying to update the community zip code is not correct';
                     sweetAlert('error',message,'alert_UpdateCommunity_Error', styleObj);
                    dispatch(updCommunityError(message));
                    return res;
                }
            })
            .catch(error => {
                dispatch(updCommunityError(error));
                const message='An error occurred trying to update the community';
                sweetAlert('error',message,'alert_UpdateCommunity_Error');
            })
    }
};

export function UpdateCommunyV2(id,data, styleObj) {
    return dispatch => {
        
        dispatch(updCommunity());
        
        fetch(API_URL_V2+'communities/community/'+id,
            {
                method: 'PUT',
                body:JSON.stringify(data),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {

                let message=''
                if(res.status===204)
                {
                    dispatch(updCommunitySuccess(res));

                    message = `The Community ${data.communityName} has been updated succesesfully`
                    sweetAlert('success',message,'alert_UpdateCommunity_Success', styleObj);

                    return res;

                } else if(res.status===400){
                     message = 'An error occurred trying to update the community zip code is not correct';
                     sweetAlert('error',message,'alert_UpdateCommunity_Error', styleObj);
                    dispatch(updCommunityError(message));
                    return res;
                }
            })
            .catch(error => {
                dispatch(updCommunityError(error));
                const message='An error occurred trying to update the community';
                sweetAlert('error',message,'alert_UpdateCommunity_Error');
            })
    }
};


export function UptOnlyRepairsEmail(communityId,repairsEmail, styleObj) {
    return dispatch => {
        
        dispatch(updCommunity());
        
        fetch(API_URL+'/communities/updEmailRepairs/'+communityId,
            {
                method: 'PUT',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'repairsEmail':repairsEmail
            }
            })
            .then(res => {

                let message=''
                if(res.status===204)
                {
                    dispatch(updCommunitySuccess(res));

                    message = `The Community has been updated successfully`
                    sweetAlert('success',message,'alert_UpdateCommunity_Success', styleObj);

                    return res;

                } else if(res.status===400){
                     message = 'An error occur trying to update repairs email';
                     sweetAlert('error',message,'alert_UpdateCommunity_Error', styleObj);
                    dispatch(updCommunityError(message));
                    return res;
                }
            })
            .catch(error => {
                dispatch(updCommunityError(error));
                const message='An error occurred trying to update repairs email';
                sweetAlert('error',message,'alert_UpdateCommunity_Error');
            })
    }
};

//#endregion

//#region  DELETE COMMUNITY
export function deleteCommunity(data) {
    return {
        type: DELETE_COMMUNITY,
        data
    }
};

export function deleteCommunitySuccess(data) {
    return {
        type: DELETE_COMMUNITY_SUCCESS,
        data
    }
};

export function deleteCommunityError(data) {
    return {
        type: DELETE_COMMUNITY_ERROR,
        data
    }
};

export function delCommunity(item) {
    return dispatch => {
        dispatch(deleteCommunity());
        fetch(API_URL+'/communities/comunity/'+ item.communityId,
            {
                method: 'DELETE',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {                  
                dispatch(deleteCommunitySuccess(item.communityId));
                return res;
            })
            .then( () =>{
                const message = `The Community ${item.name} has been deleted succesesfully`

                sweetAlert('success',message,'alert_DeleteCommunity_Success');
            })
            .catch(error => {
                dispatch(addCommunityError(error));

                const message = `An ERROR occurred trying to add the community ${item.name} `

                sweetAlert('error',message,'alert_DeleteCommunity_Success');
            })
    }
};
//#endregion

//#region  PUT USERBYCOMMUNITY

export function putUserByCommunity(data) {
    return {
        type: PUTUSERBYCOMMUNITY_COMMUNITY,
        data
    }
};

export function putUserByCommunitySuccess(data) {
    return {
        type: PUTUSERBYCOMMUNITY_COMMUNITY_SUCCESS,
        data
    }
};

export function putUserByCommunityError(data) {
    return {
        type: PUTUSERBYCOMMUNITY_COMMUNITY_ERROR,
        data
    }
};

export function PutUserByCommunity(id,data) {
    return dispatch => {
        dispatch(putUserByCommunity());
        fetch(API_URL+'communities/userByCommunity/'+id,
            {
                method: 'PUT',
                body:JSON.stringify(data),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(putUserByCommunitySuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(putUserByCommunityError(error));
            })
    }
};
//#endregion

//#region GET COMMUNITY MEALS TYPE
export function getCommunityMealTypes(data) {
    return {
        type: COMMUNITY_MEALS_TYPE,
        data
    }
};

export function getCommunityMealTypesSuccess(data) {
    return {
        type: COMMUNITY_MEALS_TYPE_SUCCESS,
        data
    }
};

export function getCommunityMealTypesError(data) {
    return {
        type: COMMUNITY_MEALS_TYPE_ERROR,
        data
    }
};

export function GetCommunityMealTypes(id) {
    
    return dispatch => {
        dispatch(getCommunityMealTypes());
        fetch(API_URL+'communities/getDiningMeals/'+id,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+ localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
              
                dispatch(getCommunityMealTypesSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getCommunityMealTypesError(error));

            })
    }
};

//#endregion

//#region UPDATE COMMUNITY IMAGE
export function updCommunityImage(data) {
    return {
        type: UPDATE_COMMUNITY_IMAGE,
        data
    }
};

export function updCommunityImageSuccess(data) {
    return {
        type: UPDATE_COMMUNITY_IMAGE_SUCCESS,
        data
    }
};

export function updCommunityImageError(data) {
    return {
        type: UPDATE_COMMUNITY_IMAGE_ERROR,
        data
    }
};

export function UpdateCommuntyImage(id,data) {
    return dispatch => {
        
        dispatch(updCommunityImage());

        
        fetch(API_URL+'communities/communityImage/'+id,
            {
                method: 'PUT',
                body:JSON.stringify(data),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(updCommunityImageSuccess(data));
                return res;
            })
            .then( () =>{
                const message = `The Community logo has been updated succesesfully`

                sweetAlert('success',message, 'alert_CommunityLogo_Success');
            })
            .catch(error => {
                dispatch(updCommunityImageError(error));
            })
    }
};

//#endregion

//#region  GET COMMUNITY TAGS
export function getCommunityTags(data){
    return {
        type: GET_TAGS_COMMUNITY,
        data: data
    }
};

export function getCommunityTagsSuccess(data){
    return{
        type: GET_TAGS_COMMUNITY_SUCCESS,
        data: data
    }
};

export function getCommunityTagsError(data){
    return{
        type: GET_TAGS_COMMUNITY_ERROR,
        data: data
    }
};

export function GetCommunityTags(){
    return dispatch => {
        
        dispatch(getCommunityTags());
        
        fetch(API_URL+'/communities/getTags',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(
                res =>{
                    dispatch(getCommunityTagsSuccess(res));                    
                }
            )
            .catch(
                error => {
                    dispatch(getCommunityTagsError(error));
                }
         )
    }
};
//#endregion

//#region  GET COMMUNITY BY TAGS
export function getCommunityByTags(data){
    return {
        type: COMMUNITY_BY_TAGS,
        data: data
    }
};

export function getCommunityByTagsSuccess(data){
    return{
        type: COMMUNITY_BY_TAGS_SUCCESS,
        data: data
    }
};

export function getCommunityByTagsError(data){
    return{
        type: COMMUNITY_BY_TAGS_ERROR,
        data: data
    }
};

export function GetCommunitiesByTags(tags){
    return dispatch => {
        dispatch(getCommunityByTags());

        fetch(API_URL+'communities/getCommunitiesByTags',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Tags':tags,
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(
                res =>{
                    dispatch(getCommunityByTagsSuccess(res))
                }
            )
            .catch(
                error => {
                    dispatch(getCommunityByTagsError(error));
                }
            )
    }
};


export function getAllCommunitiesSTBVerison(data) {

    return dispatch => {
        dispatch(getCommunityByTags());
        fetch(API_URL+'communities/communities',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+ localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
              
                dispatch(getCommunityByTagsSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getCommunityByTagsError(error));

            })
    }
};
//#endregion GET COMMUNITY BY TAGS

//#region //#region GET COMMUNITY
export function syncCLCommunity(data) {
    return {
        type: CL_COMMUNITY,
        data
    }
};

export function syncCLCommunitySuccess(data) {
    return {
        type: CL_COMMUNITY_SUCCESS,
        data
    }
};

export function syncCLCommunityError(data) {
    return {
        type: CL_COMMUNITY_ERROR,
        data
    }
};

export function SyncCLCommunity(id,data) {
    return dispatch => {
        dispatch(syncCLCommunity());
        
        fetch(API_URL+'communities/syncCl/'+id,
            {
                method: 'PUT',
                body:JSON.stringify(data),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': 'Bearer '+ localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(syncCLCommunitySuccess(res));
                let message='';
                message = `The community has been sync with Connect Living`
                sweetAlert('success',message,'alert_SyncCommunity_Success');
                return res;
            })
            .catch(error => {
                dispatch(syncCLCommunityError(error));

                const message = `An error occurred trying to sync the community with Connect Living `

                sweetAlert('error',message, 'alert_SyncCommunity_Error');

            })
    }
};

//#endregion